import {createContext, useContext} from 'react'

const HeadingContext = createContext(null)

export const useHeadingContext = () => useContext(HeadingContext)
export const HeadingProvider = HeadingContext.Provider
